// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "packs/css/" + "application" + "-" + "36047290" + ".css";
};